<main class="transaction">
    <h1> Account activity request</h1>
    <app-stepindicator [stepIndicators]="steps"></app-stepindicator>
    <section class="steps-container">
        <router-outlet></router-outlet>
    </section>
</main>
